<template>
  <div class="m-l-50 m-t-30 dimensionalChart" v-loading="isLoading">
    <common-config :id="id" :form="form" :inputList="inputList" :isLimit="false">
      <template slot="self-config">
        <!-- 显示配置开始 -->
        <div class="area">
          <span>图表配置</span>
          <p class="title">显示的图表</p>
          <div>
            <el-checkbox-group v-model="form.display.display_list">
              <el-checkbox label="table">表格</el-checkbox>
              <el-checkbox label="bar">柱状图</el-checkbox>
              <el-checkbox label="pie">饼图</el-checkbox>
            </el-checkbox-group>
            <p><el-button type="primary" size="small" @click="showLayout">页面布局</el-button></p>
            <div>
              <p class="title">表格显示方向</p>
              <el-radio-group v-model="form.display.direction">
                <el-radio :label="10">横向</el-radio>
                <el-radio :label="20">纵向</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <!-- 显示配置结束 -->
        <!-- 筛选区配置开始 -->
        <div class="area m-t-20">
          <span>筛选区配置</span>
          <div>
            <p class="title">类型</p>
            <el-radio-group v-model="form.search.type">
              <el-radio :label="10">不显示</el-radio>
              <el-radio :label="20">年</el-radio>
              <el-radio :label="30">月</el-radio>
              <el-radio :label="40">日</el-radio>
              <el-radio :label="50">年范围</el-radio>
              <el-radio :label="60">月范围</el-radio>
              <el-radio :label="70">日范围</el-radio>
            </el-radio-group>
            <p class="title">默认值</p>
            <div>
              <el-input placeholder="默认时间变量" class="w-200" v-model="form.search.default.from"></el-input>
              ~
              <el-input placeholder="默认时间变量" class="w-200" v-model="form.search.default.to"></el-input>
              <p class="line">* 时间变量说明：Y代表年，M代表月，D代表天，h代表时，m代表分，s代表秒，+1代表往前加一个单位，-1代表往后减一个单位，支持小数；可使用&进行多公式连接。</p>
              <p class="line">例如：D+1 代表明天，M+1代表下个月，h+1代表一个小时后，m+10代表十分钟后，s+30代表30秒后，不填即当前时间</p>
            </div>
          </div>
        </div>
        <!-- 筛选去配置结束 -->

        <!-- 表格配置开始 -->
        <div class="area m-t-20">
          <div class="m-t-10 table-container">
            <el-form-item label="表格配置" prop='table'>
              <el-table
                :data="form.table"
                border
                style="width: 100%"
                :row-class-name="tableRowClassName">
                <el-table-column
                  prop="name"
                  label="指标名称">
                   <template scope="scope">
                    <el-input placeholder="指标名称" v-model="scope.row.name"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="220">
                  <template scope="scope">
                    <el-button size="mini" @click="setConfig(scope.$index, scope.row)">配置</el-button>
                    <el-button v-if="scope.$index != 0" size="mini" @click="moveTr(scope.$index, 0)">上移</el-button>
                    <el-button v-if="scope.$index != form.table.length - 1" size="mini" @click="moveTr(scope.$index, 1)">下移</el-button>
                    <el-button size="mini" @click.native.prevent="deleteRow(scope.$index, form.table)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button size="small" type="primary" @click="addCol()">添加指标</el-button>
            </el-form-item>
          </div>
        </div>
        <!-- 表格配置结束 -->
        <!-- 柱状图配置开始 -->
        <div class="area m-t-20">
          <span>柱状图</span>
          <el-form ref="form" label-width="80px">
            <el-form-item label="图类型">
              <el-select placeholder='请选择' v-model="form.bar.type">
                <el-option 
                  v-for="item in barType"
                  :label="item.value" 
                  :value="item.type"
                  :key="item.type">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="颜色方案">
              <el-select placeholder="请选择活动区域" v-model="form.bar.color">
                <el-option label="深色" value="#2F4554"></el-option>
                <el-option label="浅色" value="#3398DB"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="图表标题">
              <el-radio-group v-model="form.bar.show_title">
                <el-radio :label="0">不显示</el-radio>
                <el-radio :label="1">显示</el-radio>
              </el-radio-group>
              <el-input placeholder="请输入" class="w-200" v-model="form.bar.title" v-if="form.bar.show_title == 1"></el-input>
            </el-form-item>
            <el-form-item label="图表子标题">
              <el-radio-group v-model="form.bar.show_sub_title">
                <el-radio :label="0">不显示</el-radio>
                <el-radio :label="1">显示</el-radio>
              </el-radio-group>
              <el-input placeholder="请输入" class="w-200" v-model="form.bar.sub_title" v-if="form.bar.show_sub_title == 1"></el-input>
            </el-form-item>
            <el-form-item label="数据标签">
              <el-radio-group v-model="form.bar.show_data_label">
                <el-radio :label="0">不显示</el-radio>
                <el-radio :label="1">显示</el-radio>
                <el-radio :label="2">自定义</el-radio>
              </el-radio-group>
              <el-input placeholder="请输入" class="w-200" v-model="form.bar.data_label" v-if="form.bar.show_data_label == 2"></el-input>
              <p class="line">*自定义标签：{a}（系列名称），{b}（类目值），{c}（数值）+ 单位(可空) <br />如：'{a} &ltbr /&gt {b} : {c}元'</p>
            </el-form-item>
            <el-form-item label="图例显示">
              <el-select placeholder="请选择" v-model="form.bar.legend_type">
                <el-option 
                  v-for="item in legendType"
                  :label="item.value" 
                  :value="item.type"
                  :key="item.type"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="坐标轴">
              <el-radio-group v-model="form.bar.show_axis">
                <el-radio :label="0">不显示</el-radio>
                <el-radio :label="1">显示</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="网格线">
              <el-radio-group v-model="form.bar.show_grid">
                <el-radio :label="0">不显示</el-radio>
                <el-radio :label="1">显示</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
        <!-- 柱状图配置结束 -->
        <!-- 饼图配置开始 -->
        <div class="area m-t-20">
          <span>饼图</span>
          <el-form ref="form" label-width="80px">
            <el-form-item label="图类型">
              <el-select placeholder='请选择' v-model="form.pie.type">
                <el-option 
                  v-for="item in pieType"
                  :label="item.value" 
                  :value="item.type"
                  :key="item.type">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="颜色方案">
              <el-select placeholder="请选择活动区域" v-model="form.pie.color">
                <el-option label="深色" value="深色"></el-option>
                <el-option label="浅色" value="浅色"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="图表标题">
              <el-radio-group v-model="form.pie.show_title">
                <el-radio :label="0">不显示</el-radio>
                <el-radio :label="1">显示</el-radio>
              </el-radio-group>
              <el-input placeholder="请输入" class="w-200" v-model="form.pie.title" v-if="form.pie.show_title == 1"></el-input>
            </el-form-item>
            <el-form-item label="图标子标题">
              <el-radio-group v-model="form.pie.show_sub_title">
                <el-radio :label="0">不显示</el-radio>
                <el-radio :label="1">显示</el-radio>
              </el-radio-group>
              <el-input placeholder="请输入" class="w-200" v-model="form.pie.sub_title" v-if="form.pie.show_sub_title == 1"></el-input>
            </el-form-item>
            <el-form-item label="数据标签">
              <el-radio-group v-model="form.pie.show_data_label">
                <el-radio :label="0">不显示</el-radio>
                <el-radio :label="1">显示</el-radio>
                <el-radio :label="2">自定义</el-radio>
              </el-radio-group>
              <el-input placeholder="请输入" class="w-200" v-model="form.pie.data_label" v-if="form.pie.show_data_label == 2"></el-input>
              <p class="line">*自定义标签：{a}（系列名称），{b}（数据项名称），{c}（数值）, {d}（百分比）+ 单位（可空）<br />如：'{a} &ltbr /&gt {b} : {c} ({d}%)'</p>
            </el-form-item>
            <el-form-item label="图例显示">
              <el-select placeholder="请选择" v-model="form.pie.legend_type">
                <el-option 
                  v-for="item in legendType"
                  :label="item.value" 
                  :value="item.type"
                  :key="item.type"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <!-- 饼图配置结束 -->
      </template>
    </common-config>

    <!-- 页面布局开始 -->
      <el-dialog title="页面布局" ref="layout">
        <el-button type="primary" @click="addLayout">添加布局区</el-button>
        <div class="layout-area m-t-10" v-for="(group,index) in form.display.group">
          <div class="layout-header">
            <span>布局：</span>
            <el-radio-group v-model="group.layout">
              <el-radio :label="10">一列</el-radio>
              <el-radio :label="20">两列</el-radio>
              <el-radio :label="30">三列</el-radio>
            </el-radio-group>
            <el-button type="danger" size="small" v-if="index>0" class="delCol" @click="delLayout(index)">删除</el-button>
          </div>
          <div class="drag">
              <draggable class="dragArea" :options="{group:'people'}" v-model="group.charts">
                  <div class="chart" :class="{ 
                      'layout10': group.layout==10,
                      'layout20': group.layout==20,
                      'layout30': group.layout==30,
                    }" v-for="chart in group.charts">
                    <i class="fa fa-arrows fz-24 c-blue"></i>
                    <span class="chartValue">{{chart.value}}</span>
                  </div>
              </draggable>
          </div>
        </div>
      </el-dialog>
    <!-- 页面布局技术 -->

    <!-- 指标配置开始 -->
    <el-dialog title="指标配置" ref="condition">
      <el-form ref="newTableRow" label-width="80px" :rules="rules" :model="newTableRow" v-if="isOpen">
        <el-form-item label="选择表单">
          <el-select v-model="newTableRow.config.model_id" placeholder="请选择" @change="changeField">
            <el-option
              v-for="item in tableFormList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="筛选条件" prop="config">
          <el-table
            :data="newTableRow.config.filter.filter_condition"
            border
            style="width: 100%">
            <el-table-column
              prop="name"
              label="条件名">
               <template scope="scope">
                <el-input placeholder="条件名" v-model="scope.row.name"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="field_id"
              label="选择字段">
               <template scope="scope">
                  <el-select v-model="scope.row.field_id" placeholder="请选择">
                    <el-option
                      v-for="item in tableFieldList"
                      :key="item.field_id"
                      :label="item.title"
                      :value="item.field_id">
                      {{item.title}}({{item.field}})
                    </el-option>
                  </el-select>
              </template>
            </el-table-column>
            <el-table-column
              prop="logic"
              label="逻辑">
               <template scope="scope">
                <el-select v-model="scope.row.logic" placeholder="请选择">
                  <el-option
                    v-for="item in logic"
                    :key="item.type"
                    :label="item.value"
                    :value="item.type">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              prop="value_type"
              label="值类型">
               <template scope="scope">
                <el-select v-model="scope.row.value_type" placeholder="请选择">
                  <el-option
                    v-for="item in tableType"
                    :key="item.type"
                    :label="item.value"
                    :value="item.type">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              prop="value"
              label="值">
               <template scope="scope">
                <el-input placeholder="值" v-model="scope.row.value"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="80">
              <template scope="scope">
                <el-button size="mini" @click.native.prevent="deleteRow(scope.$index, newTableRow.config.filter.filter_condition)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button size="small" @click="addTableRow">添 加</el-button>
        </el-form-item>
        <el-form-item label="条件间逻辑关系">
          <el-input type="textarea" v-model="newTableRow.config.filter.relation" :rows="4" class="w-650"></el-input>
          <el-button size="small" @click="checkValid">检查是否正确</el-button>
          <div class="line">*说明：为空则全部条件为AND关系，填写条件名和AND、OR以及括号、双引号(均为英文半角)来组合条件间的关系，慎重以免报错，若解析失败，则会以全部为AND来解析。例子：("条件名1"AND"条件名2")OR("条件名1"AND"条件名3")</div>
        </el-form-item>
        <el-form-item label="可调用清单">
          <el-table
            :data="callList"
            style="width: 100%">
            <el-table-column
              prop="type"
              label="类型"
              width="180">
            </el-table-column>
            <el-table-column
              prop="iden"
              label="标识"
              width="180">
            </el-table-column>
            <el-table-column
              prop="desc"
              label="说明"
              width="180">
            </el-table-column>
            <el-table-column
              prop="example"
              label="例子">
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="统计公式">
          <el-input type="textarea" :rows="4" v-model="newTableRow.config.formula" class="w-650"></el-input>
          <div class="line">公式中支持四则运算与括号：+ - * / ()</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveTableRowData">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 指标配置结束 -->
  </div>
</template>

<script>
  import http from '../../../../assets/js/http'
  import flowConfig from '../../../../config/flowConfig'
  import commonConfig from './commonConfig'
  import draggable from 'vuedraggable'

  export default {
    data() {
      return {
        isLoading: false,
        id: 0,
        contentId: '',
        modelId: -1,
        form: {
          name: '',  // 操作名
          rule_name: '', // 权限标识
          model_name: '',  // 所选模型
          has_condition: 0, // 是否有条件限制
          condition: {  // 限制条件
            field_id: '',
            logic: '',
            value: '',
            auth: ''
          },
          // 显示配置
          display: {
            direction: 10, // 指标方向 10横向 20纵向
            display_list: ['table', 'bar', 'pie'], // 表格：table，柱状图：bar,饼状图：pie
            group: [
              {
                layout: 10,   // 排版 10：一列，20两列，30三列
                charts: []    // 显示的图表  表格：table，柱状图：bar,饼状图：pie
              }
            ]
          },
          // 搜索配置
          search: {
            default: {
              from: '', // 开始时间
              to: ''    // 结束时间
            },
            type: 10    // 搜索类型 10不显示，20年，30月，40日，50年范围，60月范围，70日范围
          },
          table: [], // 表格配置
          // 柱状图配置
          bar: {
            color: '',       // 颜色方案
            legend_type: 0, // 图例类型 0不显示；20左上；30左边；40顶部；50右上；60右边；70底部
            data_label: '',  // 数据标签
            sub_title: '',   // 子标题
            title: '',       // 标题
            type: 10,         // 类型 10普通；20条形
            show_axis: 0,    // 是否显示坐标轴
            show_grid: 0,    // 是否显示坐标轴
            show_data_label: 0,  // 是否显示数据标签
            show_title: 0,       // 是否显示标题
            show_sub_title: 0    // 是否显示子标题
          },
          // 饼图配置
          pie: {
            color: '',       // 颜色方案
            legend_type: 0, // 图例类型 0不显示；20左上；30左边；40顶部；50右上；60右边；70底部
            data_label: '',  // 数据标签
            sub_title: '',   // 子标题
            title: '',       // 标题
            type: 10,         // 类型 10普通；20条形
            show_axis: 0,    // 是否显示坐标轴
            show_grid: 0,    // 是否显示坐标轴
            show_data_label: 0,  // 是否显示数据标签
            show_title: 0,       // 是否显示标题
            show_sub_title: 0    // 是否显示子标题
          }
        },
        newTableRow: {
          config: {
            filter: {
              filter_condition: [],
              relation: ''  // 条件间的关系
            },
            formula: '',  // 统计公式
            model_id: ''  // 表单ID
          },
          name: '',       // 指标名
          sort: 1        // 排序
        },  // 配置弹出里面的内容
        isOpen: false,
        radio: '1',
        timeAllocation: 0,
        checkList: ['复选框 A'],
        indicatorsData: [
          {
            name: '人口总数'
          },
          {
            name: '人均GDP'
          }
        ],
        // 指标配置弹出框
        conditionData: [
          {
            name: '条件名',
            field_id: '',
            logic: '',
            type: '',
            value: ''
          }
        ],
        tableFormList: [],  // 表格表单列表
        tableFieldList: [], // 表格字段列表
        // 表格逻辑条件
        logic: [
          {
            type: 10,
            value: '等于'
          },
          {
            type: 20,
            value: '大于'
          },
          {
            type: 30,
            value: '小于'
          }
        ],
        // 表格配置值类型
        tableType: [
          {
            type: 10,
            value: '常量'
          },
          {
            type: 20,
            value: '传参变量'
          },
          {
            type: 30,
            value: '时间变量'
          },
          {
            type: 40,
            value: '用户id'
          },
          {
            type: 50,
            value: '筛选区日期开始'
          },
          {
            type: 60,
            value: '筛选区日期结束'
          },
          {
            type: 70,
            value: '筛选区日期'
          }
        ],
        // 柱状图类型
        barType: [
          {
            type: 10,
            value: '普通柱状体'
          },
          {
            type: 20,
            value: '条形图'
          }
        ],
        // 饼图类型
        pieType: [
          {
            type: 10,
            value: '实心饼图'
          },
          {
            type: 20,
            value: '空心饼图'
          }
        ],
        // 柱状图图例类型
        legendType: [
          {
            type: 0,
            value: '不显示'
          },
          // {
          //   type: 20,
          //   value: '左上'
          // },
          {
            type: 30,
            value: '左边'
          },
          {
            type: 40,
            value: '顶部'
          },
          // {
          //   type: 50,
          //   value: '右上'
          // },
          {
            type: 60,
            value: '右边'
          }
          // {
          //   type: 70,
          //   value: '底部'
          // }
        ],
        // 可调用清单
        callList: [],
        rules: {
          config: []
        }
      }
    },
    methods: {
      addCol() {
        let index = this.form.table.length
        this.form.table.push({
          config: {
            filter: {
              filter_condition: [
                // {
                //   field_id: '',  // 字段id
                //   logic: 10,    // 逻辑条件 10等于；20大于；30小于
                //   name: '',     // 条件名
                //   value_type: 10,     // 参数类型 10常量；20传参变量；30时间变量；40用户id；50筛选日期开始；60筛选日期结束
                //   value: ''     // 值
                // }
              ],
              relation: ''  // 条件间的关系
            },
            formula: '',  // 统计公式
            model_id: '' // 表单ID
          },
          name: '',       // 指标名
          sort: index + 1    // 排序
        })
      },
      addTableRow() {
        this.newTableRow.config.filter.filter_condition.push({
          field_id: '',  // 字段id
          logic: 10,    // 逻辑条件 10等于；20大于；30小于
          name: '',     // 条件名
          value_type: 10,     // 参数类型 10常量；20传参变量；30时间变量；40用户id；50筛选日期开始；60筛选日期结束
          value: ''     // 值
        })
      },
      getDetail() {
        this.isLoading = true
        this.apiGet(`cms/deals/${this.id}`).then((res) => {
          if (res.code == 200) {
            this.form.name = res.data.content_name
            this.form.rule_name = res.data.rule_name
            this.form.model_name = res.data.model_name
            if (res.data.config) {
              this.form.has_condition = res.data.config.has_condition
              if (res.data.config.condition) {
                this.form.condition = res.data.config.condition
              }
              this.form.bar = res.data.config.bar
              this.form.pie = res.data.config.pie
              this.form.display = res.data.config.display
              this.form.search = res.data.config.search
              this.form.table = res.data.config.table
              this.group = res.data.config.group
            }
            this.modelId = res.data.model_id
          } else {
            _g.dealError(this, res)
          }
          this.isLoading = false
        })
      },
      moveTr(index_, type) {
        let arr = []
        if (type) {
          // 下移
          arr = this.exchangePosition(this.form.table, index_, index_ + 1)
        } else {
          // 上移
          arr = this.exchangePosition(this.form.table, index_, index_ - 1)
        }
        this.form.table = arr
        _.forEach(this.form.table, (item, index) => {
          item.sort = index + 1
        })
      },
      exchangePosition(arr, index1, index2) {
        arr[index1] = arr.splice(index2, 1, arr[index1])[0]
        return arr
      },
      setConfig(index, item) {
        // this.initFormList()
        this.newTableRow = item
        this.openDialog()
      },
      openDialog() {
        this.isOpen = true
        this.$refs.condition.open()
      },
      closeDialog() {
        this.isOpen = false
        this.$refs.condition.close()
      },
      deleteRow(index, rows) {
        rows.splice(index, 1)
      },
      initFormList() {
        // this.tableFormList = []
        this.apiGet('form/models',{ status: 1 }).then((res) => {
          if (res.code == 200) {
            _(res.data.list).forEach((field) => {
              this.tableFormList.push({
                id: field.id,
                name: field.title
              })
            })
          } else {
            _g.toastMsg(this, 'error', res.error)
          }
        })
      },
      changeField() {
        _(this.newTableRow.config.filter.filter_condition).forEach((field) => {
          field.field_id = ''
        })
      },
      saveTableRowData() {
        this.closeDialog()
      },
      // 页面布局
      async showLayout() {
        await this.initLayoutType()
        this.$refs.layout.open()
      },
      // 初始化显示类型
      initLayoutType() {
        let arr = []
        _(this.form.display.group).forEach((group) => {
          _(group.charts).forEach((chart) => {
            arr.push(chart)
          })
        })
        let charts = []
        _(this.form.display.display_list).forEach((res) => {
          let obj = {}
          if (res == 'table') {
            obj = {
              type: 'table',
              value: '表格'
            }
          } else if (res == 'bar') {
            obj = {
              type: 'bar',
              value: '柱状图'
            }
          } else if (res == 'pie') {
            obj = {
              type: 'pie',
              value: '饼图'
            }
          }
          charts.push(obj)
        })
        if (arr.length == 0) {
          this.form.display.group[0].charts = []
          this.form.display.group[0].charts = charts
        } else {
          let newArr = _.uniqBy(arr, 'type')
          if (newArr.length != this.form.display.display_list.length) {
            this.form.display.group = []
            this.form.display.group.push({
              layout: 10,
              charts: charts
            })
          }
        }
      },
      // 添加页面布局
      addLayout() {
        this.form.display.group.push({
          layout: 10,   // 排版 10：一列，20两列，30三列
          charts: []    // 显示的图表  表格：table，柱状图：bar,饼状图：pie
        })
      },
      delLayout(index) {
        _(this.form.display.group[index].charts).forEach((item) => {
          this.form.display.group[0].charts.push(item)
        })
        this.form.display.group.splice(index, 1)
      },
      /**
       * 检查表达式是否符合要求
       */
      checkValid() {
        if (!this.newTableRow.config.filter.relation || !this.newTableRow.config.filter.relation.length) {
          _g.toastMsg(this, 'warning', '表达式为空！')
          return
        }
        // 去掉空格
        let cleanFormula = this.newTableRow.config.filter.relation.replace(/\s/g, '')
        // 检测条件名是否用花括号包裹，以及括号是否为半角英文
        let result = cleanFormula.replace(/(AND)|(OR)|(\()|(\))|(\{.+?\})/g, '')
        if (result.length > 0) {
          if (result.indexOf('｛') >= 0 || result.indexOf('｝') >= 0) {
            _g.toastMsg(this, 'error', '请使用英文半角花括号！')
          } else if (result.indexOf('（') >= 0 || result.indexOf('）') >= 0) {
            _g.toastMsg(this, 'error', '请使用英文半角括号！')
          } else {
            _g.toastMsg(this, 'error', '请检查条件名是否用半角花括号包裹')
          }
          return
        }
        // 取出条件名检测是否存在
        let regexp = /\{.+?\}/g
        let conNames = cleanFormula.match(regexp)
        // 去掉表达式中的条件名只留下括号和逻辑名称
        let noNames = cleanFormula.replace(regexp, '')
        // 去掉匹配的结果中的花括号，只剩下条件名
        conNames = conNames.join('||').replace(/(\{)|(\})/g, '').split('||')
        // 检测是否有不存在的条件名
        let findUnknown = false
        let names = _.map(this.newTableRow.config.filter.relation, (item) => {
          return item.name
        })
        _(conNames).forEach((name) => {
          let findIndex = names.indexOf(name)
          if (findIndex < 0) {
            findUnknown = true
          }
        })
        if (findUnknown) {
          _g.toastMsg(this, 'error', '存在未知的条件名！')
          return
        }
        // 检测括号是否成对存在
        // 删除括号之外的字符
        let regexp2 = /[^\(\)]/g
        let onlyBracket = noNames.replace(regexp2, '')
        if (onlyBracket % 2 === 1) {
          _g.toastMsg(this, 'error', '存在未闭合的括号！')
          return
        }
        // 递归模式的替换掉所有的括号直到字符串为空
        let circleLen = onlyBracket.length / 2
        for (let i = 0; i < circleLen; i++) {
          onlyBracket = onlyBracket.replace(/\(\)/g, '')
          if (onlyBracket.length === 0) {
            break
          }
        }
        if (onlyBracket.length > 0) {
          _g.toastMsg(this, 'error', '存在未闭合的括号！')
          return
        }
        // 检测是否有无法识别的逻辑名称
        let onlyLogic = noNames.replace(/(\()|(\))/g, '')
        result = onlyLogic.replace(/(AND)|(OR)/g, '')
        if (result.length > 0) {
          _g.toastMsg(this, 'error', '存在未知的逻辑！')
          return
        }
        _g.toastMsg(this, 'success', '格式检查通过！')
      },
      /**
       * 设置必填规则
       */
      setRules() {
        if (this.rules) {
          let validatePass = (rule, value, callback) => {
            if (value.filter.filter_condition && value.filter.filter_condition.length) {
              _(value.filter.filter_condition).forEach((item) => {
                if (!item.name) {
                  callback(new Error('条件名不能为空'))
                } else if (!item.field_id) {
                  callback(new Error('数据表字段不能为空'))
                } else if (!item.logic) {
                  callback(new Error('逻辑不能为空'))
                } else if (item.value === null) {
                  callback(new Error('值不能为空'))
                }
              })
              callback()
            }
          }
          this.rules.config.push({
            validator: validatePass,
            trigger: 'change'
          })
          this.rules.config.push({
            validator: validatePass,
            trigger: 'blur'
          })
        }
      }
    },
    computed: {
      showCondition() {
        return this.form.has_condition == 1
      }
    },
    created() {
      this.id = parseInt(this.$route.params.id)
      this.contentId = parseInt(this.$route.params.contentId)
      this.getDetail()
      if (this.form.table.length == 0) {
        this.form.table.push(this.newTableRow)
      }
      this.setRules()
      this.initFormList()
    },
    components: {
      commonConfig,
      draggable
    },
    watch: {
      'newTableRow.config.model_id'() {
        if (this.newTableRow.config.model_id && this.newTableRow.config.model_id != '') {
          let id = this.newTableRow.config.model_id
          // 获取指标配置中的选择字段
          this.apiGet('cms/deals/fields/' + id).then((res) => {
            if (res.code == 200) {
              this.tableFieldList = res.data
            } else {
              _g.toastMsg(this, 'error', res.error)
            }
          })
          // 获取可调用清单的数据
          this.apiGet('cms/deals/char_vars/' + id).then((res) => {
            if (res.code == 200) {
              this.callList = res.data
            } else {
              _g.toastMsg(this, 'error', res.error)
            }
          })
        }
      },
      'form.display.display_list'() {
        this.initLayoutType()
      }
    },
    mixins: [http, flowConfig]
  }
</script>
<style>
.dimensionalChart .area{
  padding:10px;
  width: 45%;
  border: 1px solid #eee;
  background-color: #fff;
}
.dimensionalChart .title{
    font-size: 14px;
    color: #48576a;
}
.dimensionalChart .line{
  font-size: 12px;
  color: #48576a;
  line-height: 20px;
}
.dimensionalChart .indicators-area{
  width:45%;
  position:absolute;
  right:10px;
  top:0;
  border-left:1px solid;
  padding: 10px;
}
.dimensionalChart .el-dialog--small {
    width: 80%;
}
.dimensionalChart .layout-area{
  margin: 0 auto;
  border: 1px solid #cecece;
  padding: 10px;
}
.dimensionalChart .layout-header{
  border-bottom: 1px solid #cecece;
  padding-bottom: 10px;
  position: relative;
}
.dimensionalChart .layout-header .delCol{
  position: absolute;
  right: 0;
}
.dimensionalChart .chart{
  padding: 10px;
  border: 1px solid;
  margin: 10px 0;
}
.dimensionalChart .layout10{
  width: 80%;
}
.dimensionalChart .layout20{
  margin-right:3%;
  width: 42%;
  display: inline-block;
}
.dimensionalChart .layout30{
  margin-right:2%;
  width: 28%;
  display: inline-block;
}
.dimensionalChart .chartValue{
  font-size: 16px;
  margin-left: 10px;
  position: relative;
  top: -2px;
}
.dimensionalChart .dragArea{
  padding:10px 0;
}
</style>


// WEBPACK FOOTER //
// dimensionalChart.vue?4ad6fc1b